import { useTranslation } from 'react-i18next'

import { LoadingButton } from '@mui/lab'
import { Alert, Button, Dialog, DialogActions, DialogContent } from '@mui/material'

type JoinNetworkRequirementDialogProps = {
  isRequesting?: boolean
  open: boolean
  onClose?: () => void
  onJoin?: () => void
}

export default function JoinNetworkRequirementDialog(props: JoinNetworkRequirementDialogProps) {
  const { isRequesting = false, open, onClose, onJoin } = props
  const { t } = useTranslation()
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogContent>
        <Alert severity="info">{t('dialog.joinNetworkRequirement.message')}</Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="neutral">
          {t('common:button.cancel.label')}
        </Button>
        <LoadingButton loading={isRequesting} onClick={onJoin} variant="contained">
          {t('common:button.join.label')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
